import angular from 'angular';
import futureGoals from './futureGoals';

export default angular
  .module('components.futureGoals', [])
  .component('futureGoals', futureGoals).name;
